// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".arrow[data-v-6df6fa15]{height:1rem}", ""]);
// Exports
module.exports = exports;
